import { FastlyImage } from '@components/common/image'

const EditorialQuote = () => (
  <section className="py-12 lg:py-16 px-5 bg-blue-50 bg-opacity-50">
    <div className="max-w-4xl mx-auto">
      {/* Quote block */}
      <div className="relative text-center">
        <p className="text-grey-900 text-base  md:text-lg lg:text-xl leading-relaxed">
          <span
            className="text-orange text-3xl md:text-5xl font-700 leading-none select-none"
            aria-hidden="true"
          >
            &#8220;&nbsp;
          </span>
          Every parent I speak with wants the same thing: a child who is
          genuinely prepared for whatever comes next. What the research kept
          showing us, and what we see every day inside Codingal classrooms, is
          that one skill is doing more for children&apos;s cognitive
          development, academic confidence, and long-term resilience than almost
          anything else in the curriculum. The ten benefits on this page are
          peer-reviewed findings, replicated across thousands of children, and
          recognized by education policymakers worldwide. Coding does not just
          add a skill. It changes how a child thinks, how they handle
          difficulty, and how they see themselves when they face a problem they
          have never encountered before. That shift, once it happens, stays.
          <span
            className="text-orange text-3xl md:text-5xl font-700 leading-none select-none"
            aria-hidden="true"
          >
            &nbsp;&#8221;
          </span>
        </p>
      </div>

      {/* Callout card */}
      <div className="rounded-xl p-3 flex md:flex-row flex-col items-start gap-5 mt-6 bg-white">
        <div className="flex-shrink-0 rounded-xl overflow-hidden">
          <FastlyImage
            src="/images/benefits-of-coding/benefits/vivek-prakash.png"
            alt="Vivek Prakash, Co-founder and CEO of Codingal"
            width={88}
            height={96}
            className="block"
          />
        </div>
        <p className="text-grey-800 text-base italic leading-relaxed self-center">
          If you&apos;re wondering specifically what happens inside your
          child&apos;s brain when they code, Codingal&apos;s Co-founder &amp;
          CEO{' '}
          <a
            href="https://www.codingal.com/coding-for-kids/blog/what-coding-does-to-your-childs-brain/"
            className="text-blue-200 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vivek Prakash&apos;s deep dive into the neuroscience
          </a>{' '}
          is the clearest summary we&apos;ve seen.
        </p>
      </div>
    </div>
  </section>
)

export default EditorialQuote
